import { render, staticRenderFns } from "./BrandBasicTable.vue?vue&type=template&id=3179565e&scoped=true&"
import script from "./BrandBasicTable.vue?vue&type=script&lang=js&"
export * from "./BrandBasicTable.vue?vue&type=script&lang=js&"
import style0 from "./BrandBasicTable.vue?vue&type=style&index=0&id=3179565e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3179565e",
  null
  
)

export default component.exports